import mutations from './company.mutations'
import actions from './company.actions'
import getters from './company.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
